import { Pedido } from '@/models/pedido'

interface RenovacaoCertificadoTacografo{
  currentStep: number;
  isLoading: boolean;
  data: Pedido;
  documentos: Array<any>;
  error: any;
}

export const initialStateRenovacaoCertificadoTacografo: RenovacaoCertificadoTacografo = {
  currentStep: 1,
  isLoading: false,
  data: null,
  documentos: [],
  error: null,
}

export default {
  form: initialStateRenovacaoCertificadoTacografo
}
